import { Backdrop, CircularProgress } from '@mui/material';
import * as React from 'react';
import { useLoadingIndicatorStyles } from './loading-indicator.styles';

export const LoadingIndicator = React.forwardRef<
  HTMLDivElement,
  { size?: 'small' | 'standard'; fullPage?: boolean; backdrop?: boolean }
>((props, ref) => {
  const classes = useLoadingIndicatorStyles(props);

  return (
    <div className={classes.root} ref={ref}>
      {props.backdrop && <Backdrop open={true} />}
      <CircularProgress size={props.size === 'small' ? 20 : 40} />
    </div>
  );
});
